<script setup lang="ts">
import LoadingStatus from '@/assets/js/enum/LoadingStatus';

const { icon, status, smallSpinner } = defineProps<{
  icon?: string;
  status?: string;
  smallSpinner?: boolean;
}>();
</script>

<template>
  <span class="inline-loader">
    <span
      v-if="icon && (!status || status.trim() === '' || status === LoadingStatus.NONE)"
      :uk-icon="icon"
    />
    <span
      v-show="status === LoadingStatus.LOADING"
      uk-spinner
      class="uk-button-icon"
      :class="{ 'small-spinner': smallSpinner }"
    />
    <span v-show="status === LoadingStatus.SUCCESS" class="icon success">
      <span uk-icon="icon: check; ratio: 1" />
    </span>
    <span v-show="status === LoadingStatus.FAILED" class="icon failed">
      <span uk-icon="icon: close; ratio: 1" />
    </span>
  </span>
</template>

<style lang="scss" scoped>
.icon {
  align-items: center;
  border: 1px solid black;
  border-radius: 100%;
  display: inline-flex;
  height: 1.5em;
  justify-content: center;
  width: 1.5em;

  &.success {
    color: green;
    border-color: green;
  }

  &.failed {
    color: red;
    border-color: red;
  }

  .uk-button-primary &.success {
    color: white;
    border-color: white;
  }

  .uk-button-primary &.failed {
    color: white;
    border-color: white;
  }

  .uk-light &.success {
    color: black;
    border-color: black;
  }

  .uk-light &.failed {
    color: black;
    border-color: black;
  }

  .uk-dark &.success {
    color: white;
    border-color: white;
  }

  .uk-dark &.failed {
    color: white;
    border-color: white;
  }
}

.small-spinner {
  width: 0.8rem !important;
  height: 0.8rem !important;
  padding: 4px !important;
}
</style>
